import { Befehl33FormData, Befehl33FormSchema } from './schema'
import { Befehl33 } from '../../../models'
import {
  Befehl33DataDto,
  BefehlAuftrag_33_10Dto,
  Feld_33_11Dto,
  Feld_33_12Dto
} from '../../../dtos/befehl-33-dto'
import { findAuftragByKennung } from '../converter-utils'

export const convertModelToBefehl33FormData = (
  befehl?: Befehl33
): Befehl33FormData => {
  const formData = Befehl33FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  const auftrag33_10 = findAuftragByKennung(
    befehl.auftraege,
    '33.10'
  ) as BefehlAuftrag_33_10Dto

  const feld33_11 = auftrag33_10?.felder?.find(
    (feld) => feld.kennung === '33.11'
  ) as Feld_33_11Dto

  const feld33_12 = auftrag33_10?.felder?.find(
    (feld) => feld.kennung === '33.12'
  ) as Feld_33_12Dto

  let selector: '' | 'lzbBk' | 'etcsBk' = ''

  // Determine selector based on field with value
  if (feld33_11) {
    selector = 'lzbBk'
  } else if (feld33_12) {
    selector = 'etcsBk'
  }

  formData.auftrag33_10.selector = selector
  formData.auftrag33_10.feld_33_11 = feld33_11?.werte?.lzbBk || ''
  formData.auftrag33_10.feld_33_12 = feld33_12?.werte?.etcsBk || ''

  return formData
}

export const convertBefehl33FormDataToModel = (
  formData: Befehl33FormData,
  frontendId: string
): Befehl33 => {
  const auftraege: Befehl33DataDto = []

  if (formData.auftrag33_10?.enabled) {
    const { selector, feld_33_11, feld_33_12 } = formData.auftrag33_10 || {}

    const fields: Array<Feld_33_11Dto | Feld_33_12Dto> = []
    if (selector === 'lzbBk') {
      fields.push({
        kennung: '33.11',
        werte: { lzbBk: feld_33_11 || '' }
      } as Feld_33_11Dto)
    }
    if (selector === 'etcsBk') {
      fields.push({
        kennung: '33.12',
        werte: { etcsBk: feld_33_12 || '' }
      } as Feld_33_12Dto)
    }

    auftraege.push({
      kennung: '33.10',
      felder: fields
    })
  }

  return {
    kennung: '33',
    frontendId,
    auftraege
  }
}
